import React from "react";
import { Button } from "reactstrap";
import { formatDateForDisplay } from "utils/dateUtils";

export const mapInventorySearchResults = (results = []) =>
  results.map((item) => {
    const statusName = item.inventory_vehicle?.vehicle_status?.status_name || "-";
    const statusColor = item.inventory_vehicle?.vehicle_status?.color;

    return {
      id: item.documentId,
      documentId: item.documentId,
      inventoryId: item.id,
      stock: item.stock_number,
      stockNumber: item.stock_number,
      year: item.inventory_vehicle?.year || "",
      make: item.inventory_vehicle?.make
        ? item.inventory_vehicle.make.charAt(0).toUpperCase() +
          item.inventory_vehicle.make.slice(1).toLowerCase()
        : "",
      model: item.inventory_vehicle?.model || "",
      trim: item.inventory_vehicle?.trim || "",
      color: item.inventory_vehicle?.exterior_color || "",
      vin: item?.vin || item?.inventory_vehicle?.vin || "",
      location: item.location?.legal_name || "-",
      altLocation: item.alt_location?.location_name || "-",
      daysAtLocation: item.days_at_location == null ? "-" : item.days_at_location,
      acquiredDate: formatDateForDisplay(item.acquired_date),
      statusName,
      status_color: statusColor,
      status: (
        <span style={{ color: statusColor }}>{statusName}</span>
      ),
      price: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(
        Number(item.inventory_pricing?.promotional_price) > 0
          ? Number(item.inventory_pricing.promotional_price)
          : Number(item.inventory_pricing?.normal_asking_price) > 0
            ? Number(item.inventory_pricing.normal_asking_price)
            : Number(item.price) > 0
              ? Number(item.price)
              : 0
      ),
      mileage: item?.inventory_vehicle?.actual_mileage || "",
      pics: item.images_count || 0,
      vehicle_image: item.vehicle_image,
    };
  });

/** Row shape expected by worksheet / deal pickers after table selection */
export const toVehicleSelectionRow = (row) => {
  if (!row || row.is_empty) {
    return row;
  }
  return {
    ...row,
    id: row.documentId || row.id,
    status: row.statusName ?? row.status,
    stockNumber: row.stockNumber || row.stock,
  };
};

export const buildInventorySearchColumns = ({ t, showNotification }) => [
  {
    Header: t("searchInventory.stock"),
    accessor: "stock",
    Cell: ({ value }) => (
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "100%",
        }}
      >
        {value}
      </div>
    ),
  },
  { Header: t("searchInventory.year"), accessor: "year" },
  { Header: t("searchInventory.make"), accessor: "make" },
  { Header: t("searchInventory.modelTrim"), accessor: "model" },
  { Header: t("searchInventory.color"), accessor: "color" },
  {
    Header: t("searchInventory.vin"),
    accessor: "vin",
    Cell: ({ value }) => (
      <div
        className="d-flex align-items-center"
        style={{
          gap: 8,
          justifyContent: "center",
          width: "100%",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <div
          title={value || undefined}
          style={{
            fontSize: 12,
            fontWeight: 600,
            minWidth: 0,
            flex: "1 1 auto",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {value}
        </div>
        {showNotification ? (
          <Button
            color="link"
            size="sm"
            style={{ cursor: "pointer", flexShrink: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              const link = `${window.location.origin}/inventory/${value}`;
              navigator.clipboard.writeText(link);
              showNotification("success", "Link copied!");
            }}
          >
            <i className="fa fa-copy" />
          </Button>
        ) : null}
      </div>
    ),
  },
  { Header: t("searchInventory.location"), accessor: "location" },
  { Header: t("searchInventory.daysAtLocation"), accessor: "daysAtLocation" },
  { Header: t("searchInventory.acquiredDate"), accessor: "acquiredDate" },
  {
    accessor: "status",
    disableSortBy: true,
    Header: () => (
      <div style={{ textAlign: "center", width: "100%" }}>
        {t("searchInventory.status")}
      </div>
    ),
    Cell: ({ value }) => <div className="w-100 text-center">{value}</div>,
  },
  { Header: t("searchInventory.mileage"), accessor: "mileage" },
  {
    Header: t("searchInventory.pics"),
    accessor: "pics",
    Cell: ({ value }) => <div className="w-100 text-center">{value}</div>,
  },
  {
    Header: t("searchInventory.price"),
    accessor: "price",
    Cell: ({ value }) => (
      <div
        style={{
          width: "100%",
          textAlign: "right",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={typeof value === "string" ? value : undefined}
      >
        {value}
      </div>
    ),
  },
];
